import { Progress, TabBar } from "d-react-components";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Messages from "../../../languages/Messages";
import { MaterialStockRequestDetailContext } from "../../../context/material";
import MaterialAdjustRequestHeader from "./MaterialAdjustRequestHeader";
import MaterialAdjustRequestGeneral from "./MaterialAdjustRequestGeneral";
import MaterialAdjustRequestSummary from "./MaterialAdjustRequestSummary";
import MaterialAdjustRequestItems from "./MaterialAdjustRequestItems";
import MaterialAdjustRequestActivity from "./MaterialAdjustRequestActivity";
import MaterialInventoryAPI from "../../../api/queries/material-inventory";

const TABS = [
    {
        id: "general",
        label: Messages.generalInformation,
        component: <MaterialAdjustRequestGeneral />,
    },
    {
        id: "service",
        label: Messages.items,
        component: <MaterialAdjustRequestItems />,
    },
    {
        id: "activity",
        label: Messages.activity,
        component: <MaterialAdjustRequestActivity />,
    },
];

const MaterialAdjustRequestDetail = () => {
    const { requestId } = useParams<any>();
    const [requestDetail, setRequestDetail] = useState<any>();
    const [tab, setTab] = useState(TABS[0]);

    useEffect(() => {
        loadRequestDetail();
    }, []);

    const loadRequestDetail = () => {
        Progress.show(
            {
                method: MaterialInventoryAPI.detailAdjustmentRequest,
                params: [requestId],
            },
            setRequestDetail as any
        );
    };

    if (!requestDetail) {
        return <div />;
    }

    return (
        <MaterialStockRequestDetailContext.Provider
            value={{
                requestDetail,
                setRequestDetail,
            }}
        >
            <div className="flex-column-container bg-white">
                <MaterialAdjustRequestHeader />
                <div className="px-4 py-3">
                    <div className="grid grid-cols-4 gap-4">
                        <div className="col-span-1">
                            <MaterialAdjustRequestSummary />
                        </div>
                        <div className="col-span-3">
                            <TabBar
                                dataSource={TABS}
                                onChange={setTab as any}
                                value={tab}
                            />
                            <div className="bg-white mt-3">{tab.component}</div>
                        </div>
                    </div>
                </div>
            </div>
        </MaterialStockRequestDetailContext.Provider>
    );
};

export default MaterialAdjustRequestDetail;
